/* eslint-disable standard/no-callback-literal */
const baseRequirement = {
  required: true, message: 'Please fill in the correct value', trigger: 'blur'
}
const baseFileRequirement = {
  required: true, message: 'Please Upload the correct file', trigger: 'blur'
}
const BaseSignRequirement = {
  required: true, message: 'Please Sign', trigger: 'blur'
}
const emailValidator = {
  required: true, type: 'email', message: 'Please input correct email', trigger: 'blur'
}
const checkTrue = function (rule, value, callback) {
  if (value === true) {
    callback()
  } else {
    callback(false)
  }
}
const trueValidator = {
  required: true, validator: checkTrue, message: 'Please read and tick', trigger: 'change'
}
const rules = {
  broker_dob: [
    baseRequirement
  ],
  broker_surname: [
    baseRequirement
  ],
  broker_forename: [
    baseRequirement
  ],

  broker_tile: [
    baseRequirement
  ],
  broker_gender: [
    baseRequirement
  ],
  broker_is_nz_taxer: [
    baseRequirement
  ],
  broker_tax_num: [
    baseRequirement
  ],
  broker_gst_number: [
    baseRequirement
  ],
  broker_is_gst_registered: [
    baseRequirement
  ],
  broker_address: [
    baseRequirement
  ],
  broker_phone_number: [
    baseRequirement
  ],
  broker_emaill: [
    emailValidator
  ],
  broker_sign_key: [
    BaseSignRequirement
  ],
  broker_id_type: [
    baseRequirement
  ],
  broker_cn_identify_front_num: [
    baseRequirement
  ],
  broker_cn_identify_front_country: [
    baseRequirement
  ],
  broker_cn_identify_front_file_list: [
    baseFileRequirement
  ],
  broker_cn_identify_back_file_list: [
    baseFileRequirement
  ],
  broker_nz_au_driver_num: [
    baseRequirement
  ],
  broker_nz_au_driver_country: [
    baseRequirement
  ],
  broker_nz_au_driver_front_file_list: [
    baseFileRequirement
  ],
  broker_nz_au_driver_back_file_list: [
    baseFileRequirement
  ],
  broker_nz_au_passport_num: [
    baseRequirement
  ],
  broker_nz_au_passport_country: [
    baseRequirement
  ],
  broker_nz_au_passport_file_list: [
    baseFileRequirement
  ],
  broker_agreement: [
    trueValidator
  ]
}
export default rules
